// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__13Gxk","inputWrap":"styles_inputWrap__2BCRB","input":"styles_input__2LdtM"};